// ============================================================================
// Vacancy application reminder
// ============================================================================
// Visitors who open the job apply page and leave without submitting get a small
// reminder bar on their next visit to the vacancy site, offering to take them
// back to the form they left.
//
// The bar itself is rendered server side by VacancyReminderMoleculeMapDefinition,
// which reads the same cookie this file writes. Only three things have to happen
// in the browser:
//   - WRITE the cookie on the apply page. The form is a third-party Bullhorn
//     Connexys widget injected into #cxsFormHolder, so there is no native submit
//     to hook; the data comes from attributes the server already resolved.
//   - CLEAR it from the vendor's onAfterSubmit callback, which the GTM
//     'application_completed' event in JobApplyPage.cshtml already relies on.
//   - CLEAR it when the visitor dismisses the bar or withdraws consent.
//
// The cookie falls in Cookiebot's "preferences" category, following the convention
// documented in engage-browser-location.js: without that consent nothing is stored
// and anything previously stored is removed. Local environments don't load
// Cookiebot at all, so there it is written without a consent check to stay testable.
//
// Flip REQUIRES_CONSENT if this is ever reclassified as a functional cookie.

(function () {
    'use strict';

    // Must match VacancyConstants.ReminderCookieName in Vebego.Code, which reads it.
    var COOKIE_NAME = 'vebegoVacancyReminder';
    var COOKIE_MAX_AGE_SECONDS = 30 * 24 * 60 * 60;
    var REQUIRES_CONSENT = true;

    function writeReminder(reminder) {
        // encodeURIComponent escapes the comma to %2C. A raw comma is outside
        // RFC 6265 cookie-octet grammar, and ASP.NET Core Request.Cookies
        // silently drops the whole cookie when it sees one.
        document.cookie = COOKIE_NAME + '=' + encodeURIComponent(JSON.stringify(reminder)) +
            '; max-age=' + COOKIE_MAX_AGE_SECONDS +
            '; path=/; SameSite=Lax' +
            (window.location.protocol === 'https:' ? '; Secure' : '');
    }

    function deleteReminder() {
        document.cookie = COOKIE_NAME + '=; max-age=0; path=/';
    }

    function getBanner() {
        return document.querySelector('[data-vacancy-reminder]');
    }

    function removeBanner() {
        var banner = getBanner();

        if (banner) {
            banner.remove();
        }
    }

    // Apply page only: everything else on the page is server rendered.
    function record() {
        var source = document.querySelector('[data-vacancy-reminder-source]');

        if (!source) {
            return;
        }

        // This page is the abandoned form, so its own URL is what "Solliciteren" returns to.
        writeReminder({
            jobTitle: source.dataset.jobTitle || '',
            applyUrl: window.location.pathname + window.location.search,
        });
    }

    function bindDismiss() {
        var banner = getBanner();
        var dismiss = banner && banner.querySelector('[data-vacancy-reminder-dismiss]');

        if (dismiss) {
            dismiss.addEventListener('click', function () {
                deleteReminder();
                banner.remove();
            });
        }
    }

    function preferencesConsentGiven() {
        return !!(window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.preferences);
    }

    function isLocalEnvironment() {
        var hostname = window.location.hostname;
        return hostname === 'localhost'
            || hostname === '127.0.0.1'
            || hostname.endsWith('.127.0.0.1.nip.io');
    }

    function applyConsentState() {
        if (!REQUIRES_CONSENT || preferencesConsentGiven()) {
            record();
        } else {
            // Consent withdrawn or declined: clean up and take the bar off the page.
            // The server had no way of knowing, since it only sees the cookie.
            deleteReminder();
            removeBanner();
        }
    }

    // Always available, so the Connexys onAfterSubmit callback can clear the
    // reminder regardless of consent state.
    window.vebegoVacancyReminder = { clear: deleteReminder };

    bindDismiss();

    window.addEventListener('CookiebotOnConsentReady', applyConsentState);

    if (window.Cookiebot && window.Cookiebot.consent) {
        applyConsentState();
    } else if (isLocalEnvironment() || !REQUIRES_CONSENT) {
        // Local environments don't load Cookiebot: record anyway so the feature
        // stays testable, mirroring engage-browser-location.js.
        record();
    }
})();
